import { Destination } from '@addins/singlecallcard-destination/schema/destination';
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { IDestination } from '../../schema/interfaces/IDestination';
import { SelectNavigationTool } from '../../schema/select-navigation-tool';
import { DestinationProviderService } from '../../services/destination-provider/destination-provider.service';

@Component({
  selector: 'app-destination-select',
  templateUrl: './destination-select.component.html',
  styleUrls: ['./destination-select.component.scss']
})
export class DestinationSelectComponent implements OnInit, AfterViewInit, OnDestroy {
  private _selectNavigationTool = new SelectNavigationTool(this.destinationProvider);
  get selectNavigationTool(): SelectNavigationTool {
    return this._selectNavigationTool;
  }

  private _sub: Subscription[] = [];

  constructor(private destinationProvider: DestinationProviderService, private changeDetectionRef: ChangeDetectorRef) {}

  ngOnInit() {
    if (!this.destinationProvider.isReady) {
      this._sub.push(this.destinationProvider.$ready.subscribe(() => this._selectNavigationTool.refresh()));
    }
  }

  ngAfterViewInit() {
    this._sub.push(this._selectNavigationTool.onChange.subscribe(destination => this.validate(destination)));

    this.changeDetectionRef.detectChanges();
  }

  ngOnDestroy() {
    while (this._sub.length > 0) {
      this._sub.pop().unsubscribe();
    }
  }

  private validate(item: IDestination): void {
    // Sets the current destination
    const newDestination =
      this.destinationProvider.destinations.find((destination: Destination) => destination.ResAddressUid === item.selection) || null;
    const currentDestination = this.destinationProvider.value;

    // Change the current destination's value according to the choice
    if (newDestination !== null && newDestination !== currentDestination) {
      this.destinationProvider.value = newDestination;
      this.destinationProvider.select(newDestination).subscribe();
    }
  }
}
